module.exports = __webpack_public_path__ + "static/media/icon_drops.063b68de.svg";